/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrderRequestAddress
 */
export interface CreateOrderRequestAddress {
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequestAddress
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequestAddress
     */
    addressDetails?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequestAddress
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequestAddress
     */
    number?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderRequestAddress
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderRequestAddress
     */
    longitude: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequestAddress
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequestAddress
     */
    regionCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequestAddress
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequestAddress
     */
    provinceCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequestAddress
     */
    neighborhood?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequestAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequestAddress
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderRequestAddress
     */
    country?: string;
}

/**
 * Check if a given object implements the CreateOrderRequestAddress interface.
 */
export function instanceOfCreateOrderRequestAddress(value: object): value is CreateOrderRequestAddress {
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('regionCode' in value) || value['regionCode'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function CreateOrderRequestAddressFromJSON(json: any): CreateOrderRequestAddress {
    return CreateOrderRequestAddressFromJSONTyped(json, false);
}

export function CreateOrderRequestAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrderRequestAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'address': json['address'],
        'addressDetails': json['addressDetails'] == null ? undefined : json['addressDetails'],
        'street': json['street'] == null ? undefined : json['street'],
        'number': json['number'] == null ? undefined : json['number'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'regionCode': json['regionCode'],
        'countryCode': json['countryCode'],
        'provinceCode': json['provinceCode'] == null ? undefined : json['provinceCode'],
        'neighborhood': json['neighborhood'] == null ? undefined : json['neighborhood'],
        'city': json['city'] == null ? undefined : json['city'],
        'province': json['province'] == null ? undefined : json['province'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function CreateOrderRequestAddressToJSON(json: any): CreateOrderRequestAddress {
    return CreateOrderRequestAddressToJSONTyped(json, false);
}

export function CreateOrderRequestAddressToJSONTyped(value?: CreateOrderRequestAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': value['address'],
        'addressDetails': value['addressDetails'],
        'street': value['street'],
        'number': value['number'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'postalCode': value['postalCode'],
        'regionCode': value['regionCode'],
        'countryCode': value['countryCode'],
        'provinceCode': value['provinceCode'],
        'neighborhood': value['neighborhood'],
        'city': value['city'],
        'province': value['province'],
        'country': value['country'],
    };
}

